import { useOptionalAppContext } from '../../../context/AppContext.js';
import { createScenarioFactory } from '../../scenarioFactory.js';
import type { IScenarioFactory } from '../../scenarios.interface.js';

const NOOP_SCENARIO_FACTORY = createScenarioFactory();

export function useScenarioFactory(): IScenarioFactory {
  return useOptionalAppContext()?.scenarioFactory ?? NOOP_SCENARIO_FACTORY;
}
